module.exports = __webpack_public_path__ + "img/avatar-54.89fce787.png";